<template>
  <div
    v-if="!organizationLoading && !userLoading"
    class="page">
    <app-title
      :page="'Your organizations'">
      <div slot="content">
        <p class="font-size-4 mb2">Switch organizations, join someone else&rsquo;s, or create a new one.</p>
      </div>
    </app-title>
    <div class="grid grid-columns-2 grid-columns-4_sm grid-columns-5_md grid-columns-8_lg vh33 mb-margin">
      <div
        v-for="(org, key) in user.organizations"
        :key="key"
        :class="key === organization.id ? 'reverse grey-950' : 'reverse'"
        class="organization">
        <a
          v-if="key !== organization.id"
          href="/"
          class="no-underline flex px1 pb1 pt4 flex-column justify-content-flex-end align-items-center'"
          @click.prevent="changeOrg(org.name, key)">
          <h2 class="mb0">{{ org.name }}</h2>
        </a>
        <div
          v-else
          class="hgroup flex justify-items-center flex-column px1 pb1 pt3 flex flex-column justify-content-flex-end flex-start">
          <h3 class="accent-text text regular mb0">Selected</h3>
          <h2 class="mb0">{{ org.name }}</h2>
        </div>
      </div>
      <div class="joinOrganization organization orgPlaceholder rule--dark-grey rule--dashed">
        <router-link
          :class="'p1 no-underline flex align-center flex-column justify-content-center align-items-center'"
          :to="{ name: 'joinOrganization'}"
          active-class="active">
          <h3>Join another organization</h3>
          <p>(Requires an invite code)</p>
        </router-link>
      </div>
      <div class="newOrganization organization orgPlaceholder rule--dark-grey rule--dashed">
        <router-link
          :class="'p1 no-underline flex align-center flex-column justify-content-center align-items-center'"
          :to="{ name: 'newOrganization'}"
          active-class="active">
          <h3>Create a new organization</h3>
        </router-link>
      </div>
    </div>
    <div
      v-if="user.email.includes('@louderthanten.com')"
      class="grid mb-margin">
      <p class="mb0"><button
        class="button accent-button"
        @click.prevent="duplicate()">
        Duplicate {{ organization.name }}</button></p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Title from '../common/Title'

export default {
  components: {
    appTitle: Title
  },
  data () {
    return {
      currentOrg: ''
    }
  },
  computed: {
    ...mapGetters([
      'organization',
      'user',
      'userLoading',
      'organizationLoading'
    ])
  },
  watch: {
    user (value) {
      if (this.currentOrg && value.selectedOrganization !== this.currentOrg) {
        this.$router.go(this.$router.push({ name: 'settings' }))
      }
    }
  },
  mounted () {
    this.currentOrg = this.organization.id
  },
  methods: {
    changeOrg (name, key) {
      this.$store.dispatch('saveState', false)
      const payload = {
        user: this.user.id,
        org: key,
        orgName: name
      }
      this.$store.dispatch('changeOrganization', payload).then(response => {
        this.$router.push({ name: 'dashboard', query: { s: key } })
      })
    },
    duplicate () {
      this.$store.dispatch('saveState', false)
      const payload = {
        user: this.user.id,
        avatar: this.user.avatar,
        userName: this.user.displayName,
        org: this.user.selectedOrganization
      }
      this.$store.dispatch('duplicateOrganization', payload)
    }
  }
}
</script>

<style scoped>
  .organization div,
  .organization a {
    height: 100%;
    width: 100%;
    text-decoration: none;
  }
  .orgPlaceholder a {
    border: 1px dashed var(--dark-grey);
  }
  .orgPlaceholder a:link,
  .orgPlaceholder a:visited {
    background-color: var(--grey-300);
  }
  .organization a:hover {
    background-color: var(--accent);
    color: var(--white);
  }
</style>
